import React from 'react';
import { Box, Divider, IconButton, MenuItem, Popover, Stack, TextField, Tooltip, Typography } from '@mui/material';
import TuneIcon from '@mui/icons-material/Tune';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useForecastingUi } from 'src/contexts/ForecastingUiContext';

export default function ForecastNavContextMenu() {
  const { forecastNavControls } = useForecastingUi();
  const [anchorEl, setAnchorEl] = React.useState(null);

  if (!forecastNavControls) {
    return null;
  }

  const {
    forecastYear,
    canMoveForecastYearBackward,
    canMoveForecastYearForward,
    onShiftForecastYear,
    retailers = [],
    retailersLoading = false,
    selectedRetailerId,
    selectedRetailerLabel,
    onSelectRetailer,
    retailerPickOneValue,
  } = forecastNavControls;

  const open = Boolean(anchorEl);

  const handleOpen = (event) => {
    event.preventDefault();
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  return (
    <React.Fragment>
      <Tooltip title="Forecasting context">
        <IconButton size="small" aria-label="Forecasting context" onClick={handleOpen} sx={{ flexShrink: 0 }}>
          <TuneIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        slotProps={{ paper: { sx: { p: 2, width: 264 } } }}
      >
        <Stack spacing={2}>
          <Box>
            <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 700, display: 'block', mb: 0.5 }}>
              Forecast Year
            </Typography>
            <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.75}>
              <IconButton
                size="small"
                onClick={() => onShiftForecastYear?.(-1)}
                disabled={!canMoveForecastYearBackward}
                aria-label="Previous forecast year"
              >
                <ChevronLeftIcon fontSize="small" />
              </IconButton>
              <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.05 }}>
                FY{forecastYear}
              </Typography>
              <IconButton
                size="small"
                onClick={() => onShiftForecastYear?.(1)}
                disabled={!canMoveForecastYearForward}
                aria-label="Next forecast year"
              >
                <ChevronRightIcon fontSize="small" />
              </IconButton>
            </Stack>
          </Box>
          <Divider />
          <TextField
            select
            label="Retailer"
            value={selectedRetailerId}
            onChange={(event) => onSelectRetailer?.(event.target.value)}
            disabled={retailersLoading}
            size="small"
            fullWidth
            SelectProps={{
              displayEmpty: true,
              renderValue: () => selectedRetailerLabel,
            }}
            sx={{ '& .MuiSelect-select': { fontWeight: 700 } }}
          >
            {retailers.length > 1 ? <MenuItem value={retailerPickOneValue}>Pick one</MenuItem> : null}
            {retailers.length === 0 ? <MenuItem value="all">All Retailers</MenuItem> : null}
            {retailers.map((retailer) => (
              <MenuItem key={retailer.id} value={retailer.id}>
                {retailer.name}
              </MenuItem>
            ))}
          </TextField>
        </Stack>
      </Popover>
    </React.Fragment>
  );
}
